import { render, staticRenderFns } from "./v-calc.vue?vue&type=template&id=5a734439&"
import script from "./v-calc.vue?vue&type=script&lang=js&"
export * from "./v-calc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports